(() => {
  const MONEY_FALLBACK_CURRENCY = 'EUR';

  const formatMoney = (amount) => {
    const value = typeof amount === 'number' ? amount : 0;

    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(value, theme.settings && theme.settings.moneyFormat);
    }

    return (value / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: MONEY_FALLBACK_CURRENCY
    });
  };

  const escapeHtml = (value) => String(value || '').replace(/[&<>"]/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
  }[character]));

  const imageUrl = (source, size) => {
    if (!source) return '';

    if (window.theme && theme.Images && typeof theme.Images.getSizedImageUrl === 'function') {
      return theme.Images.getSizedImageUrl(source, size || '540x') || source;
    }

    return source;
  };

  const getHandleFromCard = (card) => {
    const directHandle = card.getAttribute('data-product-handle') || card.dataset.productHandle;
    if (directHandle) return directHandle;

    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';

    try {
      const url = new URL(link.href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return match && match[1] ? decodeURIComponent(match[1]) : '';
    }
  };

  const getImageMarkup = (product) => {
    const image = product.featured_image || product.image || '';

    if (!image) {
      return `<div class="lorenzos-collection-card__placeholder">${escapeHtml(product.title)}</div>`;
    }

    return `<img class="lorenzos-collection-card__image" src="${escapeHtml(imageUrl(image, '540x'))}" alt="${escapeHtml(product.title)}" loading="lazy">`;
  };

  const getUnitPriceMarkup = (variant) => {
    if (!variant || !variant.unit_price || !variant.unit_price_measurement) return '';

    const measurement = variant.unit_price_measurement;
    let baseUnit = '';

    if (measurement.reference_value && Number(measurement.reference_value) !== 1) {
      baseUnit += measurement.reference_value + ' ';
    }

    if (measurement.reference_unit) {
      baseUnit += measurement.reference_unit;
    }

    if (!baseUnit) return '';

    return `<div class="lorenzos-collection-card__unit-price">${formatMoney(variant.unit_price)}/${escapeHtml(baseUnit)}</div>`;
  };

  const getPriceMarkup = (product) => {
    const firstVariant = product.variants && product.variants[0] ? product.variants[0] : null;
    const price = typeof product.price_min === 'number' ? product.price_min : product.price;
    const comparePrice = product.compare_at_price || (firstVariant && firstVariant.compare_at_price) || 0;
    const hasSale = comparePrice && comparePrice > price;
    const varies = product.price_varies || (product.variants && product.variants.length > 1 && product.price_min !== product.price_max);

    return `
      <div class="lorenzos-collection-card__price-row">
        ${hasSale ? `<s class="lorenzos-collection-card__compare-price">${formatMoney(comparePrice)}</s>` : ''}
        <span class="lorenzos-collection-card__price">${varies ? 'ab ' : ''}${formatMoney(price)}</span>
      </div>
      ${getUnitPriceMarkup(firstVariant)}
      <div class="lorenzos-collection-card__tax">Inkl. MwSt., <a href="/policies/shipping-policy">zzgl. Versand</a></div>
    `;
  };

  const getActionsMarkup = (product) => {
    const firstVariant = product.variants && product.variants[0] ? product.variants[0] : null;
    const hasMultipleVariants = product.variants && product.variants.length > 1;
    const available = product.available && firstVariant && firstVariant.available !== false;

    if (available && firstVariant && !hasMultipleVariants && !product.requires_selling_plan) {
      return `
        <form method="post" action="/cart/add" class="lorenzos-collection-card__form">
          <input type="hidden" name="id" value="${firstVariant.id}">
          <input type="hidden" name="quantity" value="1">
          <button type="submit" class="lorenzos-collection-card__button" aria-label="${escapeHtml(product.title)} in den Warenkorb legen">In den Warenkorb</button>
        </form>
      `;
    }

    if (available) {
      return `<a href="${escapeHtml(product.url)}" class="lorenzos-collection-card__button lorenzos-collection-card__button--secondary">${hasMultipleVariants ? 'Auswahl ansehen' : 'Produkt ansehen'}</a>`;
    }

    return `<a href="${escapeHtml(product.url)}?notify=true#back-in-stock" class="lorenzos-collection-card__button lorenzos-collection-card__button--secondary">Benachrichtigen lassen</a>`;
  };

  const buildCardMarkup = (product) => `
    <div class="grid__item lorenzos-collection-card__item">
      <article class="lorenzos-collection-card${product.available ? '' : ' lorenzos-collection-card--sold-out'}" data-product-handle="${escapeHtml(product.handle)}" data-product-id="${product.id}">
        <div class="lorenzos-collection-card__media">
          <a href="${escapeHtml(product.url)}" class="lorenzos-collection-card__image-link" aria-label="${escapeHtml(product.title)} ansehen">
            ${getImageMarkup(product)}
          </a>
          ${product.available ? '' : '<span class="lorenzos-collection-card__badge">Bald wieder verf&uuml;gbar</span>'}
        </div>
        <div class="lorenzos-collection-card__body">
          <a href="${escapeHtml(product.url)}" class="lorenzos-collection-card__title">${escapeHtml(product.title)}</a>
          <div class="lorenzos-collection-card__reviews" data-lorenzos-recent-review="${product.id}">
            <div class="jdgm-widget jdgm-preview-badge" data-id="${product.id}" data-auto-install="false"></div>
          </div>
          ${getPriceMarkup(product)}
          <div class="lorenzos-collection-card__actions">${getActionsMarkup(product)}</div>
        </div>
      </article>
    </div>
  `;

  const hydrateReviewBadge = (product, card) => {
    const holder = card.querySelector('[data-lorenzos-recent-review]');
    if (!holder || !product.url) return;

    fetch(product.url, { credentials: 'same-origin' })
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const source = doc.querySelector(`.jdgm-preview-badge[data-id="${product.id}"]`);

        if (!source || !source.innerHTML.trim()) {
          holder.remove();
          return;
        }

        const badge = holder.querySelector('.jdgm-preview-badge');
        if (badge) {
          badge.innerHTML = source.innerHTML;
        }
      })
      .catch(() => {
        holder.remove();
      });
  };

  const getLegacyCards = (grid) => Array.from(grid.children).filter((child) => {
    if (!(child instanceof HTMLElement)) return false;
    if (child.classList.contains('lorenzos-collection-card__item')) return false;
    return Boolean(getHandleFromCard(child));
  });

  const activateGrid = (grid) => {
    if (!grid.querySelector('.lorenzos-collection-card__item')) return;

    grid.classList.add('lorenzos-related-products-grid');
    if (!Array.from(grid.classList).some((className) => className.indexOf('lorenzos-related-products-grid--') === 0)) {
      grid.classList.add('lorenzos-related-products-grid--5');
    }
  };

  const convertCard = (card, grid) => {
    const handle = getHandleFromCard(card);
    if (!handle || card.dataset.lorenzosRecentConvert === 'pending') return;

    card.dataset.lorenzosRecentConvert = 'pending';

    fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((product) => {
        if (!product || !product.handle) return;

        const wrapper = document.createElement('div');
        wrapper.innerHTML = buildCardMarkup(product).trim();
        const newCard = wrapper.firstElementChild;
        if (!newCard) return;

        card.replaceWith(newCard);
        hydrateReviewBadge(product, newCard);
        activateGrid(grid);
      })
      .catch(() => {
        card.dataset.lorenzosRecentConvert = 'failed';
      });
  };

  const enhanceGrid = (grid) => {
    if (!grid || grid.dataset.lorenzosRecentGrid === 'done') return;

    const cards = getLegacyCards(grid);

    if (!cards.length) {
      activateGrid(grid);
      return;
    }

    cards.forEach((card) => convertCard(card, grid));
  };

  const enhanceAll = () => {
    document.querySelectorAll('.lorenzos-recently-viewed [id^="RecentlyViewed-"], [data-section-type="recently-viewed"] [id^="RecentlyViewed-"]').forEach(enhanceGrid);
  };

  const start = () => {
    enhanceAll();

    let runs = 0;
    const timer = window.setInterval(() => {
      enhanceAll();
      runs += 1;
      if (runs >= 20) {
        window.clearInterval(timer);
      }
    }, 400);

    document.querySelectorAll('[data-section-type="recently-viewed"]').forEach((section) => {
      const observer = new MutationObserver(() => enhanceAll());
      observer.observe(section, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('page:loaded', enhanceAll);
})();
